<template>
  <b-container style="text-align: left !important">
    <b-row>
      <b-col cols="7">
        <span style="font-size: 24px; font-weight: bold">เอกสารโครงการ</span>
        <span class="ml-3">{{ firstTotal }} รายการ</span>
      </b-col>
      <b-col cols="5">
        <b-button
          style="
            background: #db7f50;
            border-radius: 25px;
            border: 0;
            font-size: 14px;
          "
          class="w-100"
          @click="openLink('https://bedolib.bedo.or.th/')"
          >ห้องสมุดความหลากหลายทางชีวภาพ ออนไลน์</b-button
        >
      </b-col>
      <b-col cols="12" class="mt-5">
        <b-form inline>
          <label class="pl-3" for="select10">หมวดหมู่ :</label
          ><b-form-select
            id="select10"
            class="ml-2 custom-select-filter"
            :options="dataCateName"
            v-model="selectedGroup"
            value-field="id"
            text-field="name"
            deselect-label="ยกเลิก"
            @change="changeGroup"
          ></b-form-select>
        </b-form>
        <div v-for="(x, i) in data" :key="i">
          <b-row v-if="i == selectedGroup">
            <b-col
              class="mt-2 download-content"
              v-for="(y, i) in x"
              :key="i"
              cols="12"
            >
              <div>
                <span class="float-left">{{ y.name }}</span>
                <button
                  class="px-3 py-1 float-right"
                  style="
                    border-radius: 25px;
                    background: #41634a;
                    color: white;
                    border: 0;
                  "
                  v-if="y.file[0]"
                  @click="download(y.file[0])"
                >
                  ดาวน์โหลด
                </button>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { domain } from "@/utils/Constants";

export default {
  name: "document_first",
  props: {
    data: Object,
    dataCateName: Array,
    firstTotal: Number,
    selectedGroup: Number,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    download(file) {
      // console.log(file);
      window.open(domain + file.file);
    },
    changeGroup() {
      this.firstTotal = this.data[this.selectedGroup].length;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style>
.download-content {
  background: #ffffff;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 15px;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border-color: white white #db7f50 !important;
}
.nav-tabs {
  border: none !important;
}
.nav-tabs a {
  color: black !important;
  font-size: 18px;
}
.custom-select-filter {
  border-radius: 25px !important;
  border: 1px solid rgba(219, 127, 80, 1) !important;
}
</style>
